import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import {
  Header,
  Home,
  CaseStudy,
  Footer,
  NotFound,
} from "./components/Portfolio";
import { projects } from "./data/projects";

function PageNavigation() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const project = projects.find((p) => pathname === `/work/${p.id}`);
    document.title = project
      ? `${project.name} — Max Zhang`
      : "Max Zhang — Data Science & Applied AI";
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      if (!description.hasAttribute("data-default")) {
        description.setAttribute(
          "data-default",
          description.getAttribute("content") || "",
        );
      }
      description.setAttribute(
        "content",
        project
          ? `${project.title} ${project.summary}`
          : description.getAttribute("data-default") || "",
      );
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    canonical?.setAttribute("href", `https://maxweiyizhang.me${pathname}`);
    const frame = requestAnimationFrame(() => {
      if (hash) {
        document.getElementById(hash.slice(1))?.scrollIntoView();
      } else {
        window.scrollTo(0, 0);
        document.getElementById("main-content")?.focus({ preventScroll: true });
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}
const App: React.FC = () => (
  <BrowserRouter>
    <PageNavigation />
    <div id="top" />
    <a className="skip-link" href="#main-content">
      Skip to content
    </a>
    <Header />
    <main id="main-content" tabIndex={-1}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work/:id" element={<CaseStudy />} />
        <Route path="/work" element={<Navigate to="/#work" replace />} />
        <Route path="/cloudsway" element={<Navigate to="/work/cloudsway" replace />} />
        {Object.entries({
          projects: "work",
          experience: "experience",
          about: "about",
          skills: "experience",
          powerlifting: "about",
          contact: "contact",
        }).map(([path, anchor]) => (
          <Route
            key={path}
            path={`/${path}`}
            element={<Navigate to={`/#${anchor}`} replace />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
  </BrowserRouter>
);
export default App;
